<div class="search-result-view-gallery h-full">
  <ul class="search-result-view-gallery__items h-full">
    <cdk-virtual-scroll-viewport
      [itemSize]="resultViewService.defaultRows.gallery.tileHeight"
      [style.width]="width"
      class="scroll-viewport-height"
      [ngClass]="{'folder': searchContainer.currentPathView.search_view.search_view_type === 'folder',
                  'open': searchContainer.isFolderInfoOpen}"
    >
      <ng-container *cdkVirtualFor="let searchRow of ds">
        @if (!searchRow) {
          <ng-container>
            <li class="search-result-view-gallery__item">
              Loading...
            </li>
          </ng-container>
        }
        @else {
          <ng-container>
            @for (art of searchRow.columns; track $index) {
              <li class="search-result-view-gallery__item">
                <div class="search-result-view-gallery__checkbox">
                  <div
                    class="checkbox-underlay"
                    [ngClass]="{'disabled': art['$$used']}"
                  >
                    <span
                      class="checkbox-tooltip-wrapper"
                      [class.cursor-not-allowed]="isCheckboxDisabled(art) && !art.$$used"
                      [matTooltip]="isCheckboxDisabled(art) && !art.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
                      (click)="$event.stopPropagation()"
                      (keydown)="null"
                    >
                      <mat-checkbox
                        class="white-bg-in-checkbox"
                        (click)="select(art, $event)"
                        (keydown)="null"
                        [checked]="isCheckboxSelected(art)"
                        [disabled]="isCheckboxDisabled(art)"
                      ></mat-checkbox>
                    </span>
                  </div>
                </div>

                <a
                  [routerLink]="getRouterLink(art)"
                  [queryParams]="art.$$refData?.queryParams"
                  queryParamsHandling="merge"
                  (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'])"
                  class="search-result-view-gallery__item-image-container"
                  [ngClass]="{'folder': art.object_type === 'folder'}"
                >
                  @if (art.$$imageUrl) {
                    <img
                      alt="{{art.artifact_name}}"
                      [src]="art.$$imageUrl"
                    >
                  }
                  @else {
                    <i
                      class="{{art.$$noImageIcon}} noImgIcon"
                      [ngClass]="{'text-blue': art.object_type === 'folder'}"
                    ></i>
                  }

                  <div class="search-result-view-gallery__item-information">
                    <div class="search-result-view-gallery__item-information-name-container">
                      <div class="search-result-view-gallery__item-information-icon">
                        <i class="object-icon {{art.$$icon}}"></i>
                      </div>

                      <div class="search-result-view-gallery__item-information-name bold text-link">
                        <span
                          class="object-url-content"
                          [innerHTML]="art.$$name"
                        ></span>
                      </div>
                    </div>

                    @for (field of art.overview_simple; track $index) {
                      <div class="search-result-view-gallery__item-information-fields">
                        @if ($index < 2) {
                          <div class="search-result-view-gallery__item-information-fields-container">
                            @if (!field.artifact_id) {
                              <span>
                                {{field.value}}
                              </span>
                            }
                            @else {
                              <span>
                                <app-object-url [object]="field">
                                  <div class="object-url-content">
                                    <span class="text-link">
                                      {{field.value}}
                                    </span>
                                  </div>
                                </app-object-url>
                              </span>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </a>
              </li>
            }
          </ng-container>
        }
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </ul>
</div>
